import { Action } from 'redux';
import { DisqualificationState } from '../store.types';

export const initialState: DisqualificationState = {
  disqualifiedFields: []
};

export interface DisqualificationAction extends Action {
  payload: {
    field: string;
  };
}

const disqualification = (state = initialState, action: DisqualificationAction) => {
  switch (action.type) {
    case 'DISQUALIFY_USER':
      if (!state.disqualifiedFields.includes(action.payload.field)) {
        const newState = {
          disqualifiedFields: [...state.disqualifiedFields, action.payload.field]
        };
        return newState;
      }
      return state;

    case 'QUALIFY_USER':
      if (state.disqualifiedFields.includes(action.payload.field)) {
        const newState = {
          disqualifiedFields: [
            ...state.disqualifiedFields.filter(field => field !== action.payload.field)
          ]
        };
        return newState;
      }
      return state;

    default:
      return state;
  }
};

export default disqualification;
